import { useRef, useState } from "react";
import "./LiveCard.css";

import { MdKeyboardArrowRight } from "react-icons/md";
import save from '../image/save.svg';
import share from '../image/share.svg';
import like from '../image/like.svg';

import { API_BASE_URL } from '../../utils'
import ShareModal from "./ShareModal";


const LiveCard = ({ data }) => {

  const [isLoaded, setIsLoaded] = useState(false);

  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [currentShareUrl, setCurrentShareUrl] = useState('');
  const [shareTitle, setShareTitle] = useState('');





  const uploadBase = `${API_BASE_URL}/master/assets/uploads/`;


  const isAbsURL = (url) => {
    const ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
    return ABSOLUTE_URL_REGEX.test(url);
  }

  const getImageURL = (url) => {
    if (url) {
      if (isAbsURL(url)) {
        return url;
      } else {
        return uploadBase + url;
      }
    } else {
      return url;
    }
  }

  const eventUrl = (eventData) => {
    return `https://www.partywitty.com/${(eventData.cityName?.replace(/ /g, "-") || "").toLowerCase()}/${(eventData.areaName?.replace(/ /g, "-") || "").toLowerCase()}/${(eventData.clubName?.trim().split(/ +/).join("-").replace(/ /g, "-") || "").toLowerCase()}/event/${(eventData.name?.trim().split(/ +/).join("-").replace(/ /g, "-") || "").toLowerCase()}`;
  };


  // const slug = `${eventData.name}@${eventData.clubName}@${eventData.event_date}`;
  // const safeSlug = encodeURIComponent(slug);

  // const eventUrl = `https://www.partywitty.com/${eventData.cityName.toLowerCase().replace(/ /g, "-")}/${eventData.areaName.toLowerCase().replace(/ /g, "-")}/${eventData.clubName.toLowerCase().replace(/ /g, "-")}/event/${safeSlug}`;


  //const isMobileApp = () => {
  //   const ua = navigator.userAgent || navigator.vendor || window.opera;

  //   // Detect Android or iOS
  //   if (/android/i.test(ua)) return 'android';
  //   if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return 'ios';

  //   return 'web';
  // };


  // const handleDeepLink = () => {
  //   const platform = isMobileApp();

  //   if (platform === 'android') {
  //     window.location.href = 'yourapp://event/123'; // Custom URI scheme
  //   } else if (platform === 'ios') {
  //     window.location.href = 'yourapp://event/123';
  //   } else {
  //     // Fallback to website
  //     window.location.href = 'https://partywitty.com/';
  //   }
  // };

    const handleShare = (e, eventData) => {
    e.preventDefault();
    e.stopPropagation();

    const url = eventUrl(eventData);
    setCurrentShareUrl(url);
    setShareTitle(`Check out ${eventData.name} at ${eventData.clubName}`);
    setIsShareModalOpen(true);
  };





  return (
    <>
      <div className="reel-card">
        {/* Header */}
        <div className="card-header">
          <img
            className="profile-img"
            src={getImageURL(data.clubLogo)}
            alt="Club"
          />
          <div className="header-text">
            <h4>{data?.clubName}</h4>
            <p>{data.cityName}, {data?.distance} Km</p>
          </div>
          <div
            className="dots"
            onClick={(e) => handleShare(e, data)}
          >
            •••
          </div>
        </div>


        {/* Offer strip */}
        <div className="offer-strip">
          Add On up to 50% Extra on Food & Beverages
        </div>
        {/* Banner */}
        <div className="card-banner">

          <div className="image-wrapper">

            {!isLoaded && (
              <div className="ec-skeleton ec-shimmer"></div>
            )}
            <img
              src={getImageURL(data?.image)}
              alt="Live Music image"
              className={`event-img ${isLoaded ? 'visible' : 'hidden'}`}
              onLoad={() => setIsLoaded(true)}
            />
          </div>


          <div className="label-banner">{data?.event_date}</div>

          <div className="event-details">
            <h3>{data?.name}</h3>
            <p>{data?.clubName}</p>
            <div className="event-t-btn">
              <div className="event-info">
                <p>📅 {data?.event_date}</p>
                <p>⏰ {data?.event_time}</p>
              </div>
            </div>
          </div>
        </div>
        {/* CTA Button */}
        <div className="cta-button">Book Now <span className="arrow-icon-live"><MdKeyboardArrowRight /></span></div>

        <div className="card-icons">
          <div>
            <img src={save} alt="" />
          </div>
          <div className="card-icons-right">
            <div>
              <img src={like} alt="" />
            </div>
            <div>
              <img src={share} alt="" />
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="card-footer">
          {/* <p>❤️ Liked by XYZ Club and others</p> */}
          <div className="footer-text-skeleton">
            <p><div className="ec-skeleton ec-shimmer"></div></p>
          </div>
          <div className="icons">
            <span>🔗</span>
            <span>🔖</span>
          </div>
        </div>
      </div>
      <ShareModal
        isOpen={isShareModalOpen}
        onClose={() => setIsShareModalOpen(false)}
        shareUrl={currentShareUrl}
        title={shareTitle}
      />
    </>
  );
};

export default LiveCard;
